var lessons_slider = ( function ( $ ) {

	var $carousel;

	var _init = function() {
		$carousel = $( '#lesson-carousel' );

		_setup_carousel();
	};

	var _setup_carousel = function() {
		$carousel.owlCarousel( {
			items : 1,
			dots : false,
			responsive:{
				0 : {
					items : 2
				},
				768 : {
					items : 5
				},
				1200 : {
					items : 7
				}
			},
			nav : true,
			navText: [
				'<',
				'>'
			]
		} );
	};

	if ( $( '#lesson-carousel' ).length > 0 ) {
		$( document ).ready( _init );
	}

	return {};

})( jQuery );

module.exports = lessons_slider;